var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPatientRights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 2C9.48415 4.42014 6.13363 5.74751 2.66445 5.69847C2.22315 7.06033 1.99886 8.4847 2 9.91805C2 16.212 6.24889 21.4997 12 23C17.7511 21.5008 22 16.2131 22 9.91918C22 8.44474 21.7667 7.02546 21.3356 5.69734H21.1667C17.6156 5.69734 14.3889 4.29269 12 2Z",
    stroke: "#4F576D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 8.256C14.2962 8.01676 13.5432 7.94375 12.8042 8.04309C12.0651 8.14244 11.3615 8.41124 10.7524 8.82695C10.1433 9.24265 9.64649 9.79315 9.30361 10.4323C8.96072 11.0714 8.78177 11.7804 8.78177 12.5C8.78177 13.2196 8.96072 13.9286 9.30361 14.5677C9.64649 15.2069 10.1433 15.7573 10.7524 16.1731C11.3615 16.5888 12.0651 16.8576 12.8042 16.9569C13.5432 17.0562 14.2962 16.9832 15 16.744M8 11.5H13.4444M8 13.5H13.4444",
    stroke: "#4F576D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientRights);
export default __webpack_public_path__ + "static/media/patient-rights.5d474077f3dcbe29bf0922619f78fb8c.svg";
export { ForwardRef as ReactComponent };